import {
  Authenticator,
  Flex,
  Grid,
  Image,
  useTheme,
  View,
} from "@aws-amplify/ui-react";
import style from "./CustomLogin.module.css";

import { Header } from "./Header";
import { Footer } from "./Footer";
import { SignInHeader } from "./SignInHeader";
import { SignInFooter } from "./SignInFooter";
import logoLogin from "../../images/logoforlogin.png";
import { I18n } from "aws-amplify/utils";
import { translations } from "@aws-amplify/ui-react";
I18n.setLanguage("ru");

I18n.putVocabulariesForLanguage("ru", {
  "Sign in": "Войти", // Button label
  "Reset password": "Forgot your password?",
});

const components = {
  // Header,
  SignIn: {
    Header: SignInHeader,
    Footer: SignInFooter,
  },
  Footer,
};

const formFields = {
  signIn: {
    username: {
      label: "",
      placeholder: "Имя пользователя",
    },
    password: {
      label: "",
      placeholder: "Пароль",
      isRequired: false,
    },
  },
};

// function Login() {
//   const { tokens } = useTheme();

//   return (
//     <Grid templateColumns={{ base: "1fr", medium: "1fr 1fr" }}>
//       <View height="100vh" className={style.loginBackground}>
//         <div className={style.wrapperLoginPageForLeftSide}>
//           <img src={logoLogin} />

//           <div className={style.mainTitle}>
//             Behavioral
//             <br /> intelligenge
//             <br />
//             at scale
//           </div>

//           <div className={style.loginText}>
//             Unlock the full potential of your workforce <br /> with our
//             Marketing module. Learn how to align HR and Marketing for maximum
//             impact.
//           </div>

//           <div className={style.loginText}>
//             Discover how our platform can help other departments.
//             <br /> Refer a colleague and get rewarded. Our customization modules
//             include HR, Marketing and Security.
//           </div>
//         </div>
//       </View>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//         }}
//       >
//         <Authenticator
//           style={{
//             borderRadius: "8px",
//           }}
//           formFields={formFields}
//           components={components}
//           hideSignUp
//         >
//           {({ signOut, user }) => (
//             <main>
//               <h1>Hello {user.username}</h1>
//               <button onClick={signOut}>Sign out</button>
//             </main>
//           )}
//         </Authenticator>
//       </div>
//     </Grid>
//   );
// }

function Login() {
  const { tokens } = useTheme();

  return (
    <Grid templateColumns={{ base: "1fr", medium: "1fr 1fr" }}>
      <View height="100vh" className={style.loginBackground}>
        <div className={style.wrapperLoginPageForLeftSide}>
          <img src={logoLogin} />
          <div className={style.mainTitle}>
            Behavioral
            <br /> intelligence
            <br />
            at scale
          </div>
          <div className={style.loginText}>
            Unlock the full potential of your workforce <br /> with our
            Marketing module. Learn how to align HR and Marketing for maximum
            impact.
          </div>
          <div className={style.loginText}>
            Discover how our platform can help other departments.
            <br /> Refer a colleague and get rewarded.
          </div>
        </div>
      </View>

      {/* Updated Authenticator div */}
      <div className={style.authContainer}>
        <Authenticator
          style={{
            borderRadius: "8px",
            width: "100%",
            maxWidth: "400px", // Limits width on large screens
          }}
          formFields={formFields}
          components={components}
          hideSignUp
        >
          {({ signOut, user }) => (
            <main>
              <h1>Hello {user.username}</h1>
              <button onClick={signOut}>Sign out</button>
            </main>
          )}
        </Authenticator>
      </div>
    </Grid>
  );
}

export default Login;
